<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
	<div class="supplier-box mdc-layout-grid">
		<div class="mdc-layout-grid__inner">
			<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 supplier-box__label">Status</div>
			<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8">
				{{status}} <span v-if="hasExpired">(expires on {{expireDate}})</span>
			</div>

			<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 supplier-box__label">Supplier</div>
			<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8">
				{{apikey.supplier}}
			</div>

			<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 supplier-box__label">Email</div>
			<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8">
				{{apikey.email}}
			</div>

			<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 supplier-box__label">Date</div>
			<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8">
				{{creationDate}}
			</div>

			<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 supplier-box__label">Permissions</div>
			<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8">
				{{apikey.permissions}}
			</div>

			<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 supplier-box__revoke-btn">
				<a class="mdc-button mdc-ripple-upgraded" @click="revoke">Revoke Access</a>
			</div>
		</div>

	</div>
</template>


<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';
import utils from '@/libs/mixins.js';

export default {
	props: {
		apikey: Object,
	},
	data: function() {
		return {

		}
	},
	computed: {
		creationDate: function() {
			return this.dateFormatted(this.apikey.created_at);
		},
		hasExpired: function() {
			const now = new Date().getTime();
			return this.apikey.access_token_expiration > now;
		},
		expireDate: function() {
			return this.dateFormatted(this.apikey.access_token_expiration);
		},
		status: function() {
			if(this.apikey.activated) {
				return 'Active';
			}

			if(this.hasExpired) {
				return 'Waiting supplier activation';
			} else {
				return 'Expired';
			}
		}
	},
	methods: {
		revoke: function() {
			if(confirm('Are you sure?')) {
				this.$emit('revoke');
			}
		}
	},
	mixins: [utils]
}
</script>



// WEBPACK FOOTER //
// src/components/APIKey.vue